/** Checks whether given custom field value is empty. */
export function isCustomFieldValueEmpty(value) {
    return ((value === null || value === void 0 ? void 0 : value.value) === undefined ||
        (value.data_type === 'string' && value.value === ''));
}
